import { FC } from 'react';

import { signInFlowViews } from './signInFlowViews';
import { AuthFlowController } from '../../../../modules/auth';
import { SignInFlowViewId } from '../../types';

export const SignInFlowController: FC = () => {
  return (
    <AuthFlowController
      views={signInFlowViews}
      rootViewId={SignInFlowViewId.SIGN_IN}
      clearStackOnRootView
    />
  );
};
